module.exports = __webpack_public_path__ + "img/B1.a4af45ac.svg";